// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"N2-z"};